import { MixedSpace, SpaceType, getPathForSpace, storedHistory } from 'account-hybrid/common/components/spaces';
import * as fromSpaces from 'account-hybrid/common/components/spaces/store/reducers/spaces.reducer';
import { SessionService } from 'account-hybrid/core/authentication';

/**
 * WS4 inc 5 (Track A) — shared space-resolution for the global redirect states
 * (curation-all / feedback-all / recommendation / invitation / timeline / curate-guest).
 * VERBATIM port of the logic copy-pasted across the 7 AngularJS state-config
 * controllers (`session.get()` → `fromSpaces.createSpaces(...)` → `find` by
 * SpaceType + slug/companyCode). Extracted ONCE so all redirect components share
 * the identical resolution (states-map duplication risk).
 */

/** The v1 loader spinner shown while the redirect resolves (verbatim from the state configs). */
export const REDIRECT_SPINNER_TEMPLATE = `
    <div class="ft-loader-orgswitch">
        <div class="ft-cube-face-single">
            <div class="ft-content">
                <div class="ft-loading-message">
                    Loading <div class="ft2-spinner"></div>
                </div>
            </div>
        </div>
    </div>
            `;

export function buildSpaces(session: SessionService): any[] {
  const userSession = session.get() as any;
  return fromSpaces.createSpaces({
    companies: userSession.Companies,
    properties: userSession.Properties,
    history: storedHistory(),
  });
}

/** curation-all / feedback-all / recommendation / timeline / curate-guest: Property by slug, else Mixed. */
export function findPropertyOrMixedSpace(spaces: any[], companyCode: string, propertySlug: string): any {
  return (
    spaces.find((s) => s.type === SpaceType.Property && s.slug === propertySlug) ||
    spaces.find((s) => s.type === SpaceType.Mixed && s.slug === `${companyCode}-${propertySlug}`)
  );
}

/** invitation: Company by companyCode, else Mixed by the mixed space's company slug. */
export function findCompanyOrMixedSpace(spaces: any[], companyCode: string): any {
  return (
    spaces.find((s) => s.type === SpaceType.Company && s.slug.toLowerCase() === companyCode.toLowerCase()) ||
    spaces.find((s: MixedSpace) => s.type === SpaceType.Mixed && s.company.slug.toLowerCase() === companyCode.toLowerCase())
  );
}

export { getPathForSpace };
